import { useState } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { deleteSysMailTemplate } from "./sysMailTemplatesSlice";
import { Alert, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import { Localized } from "@fluent/react";
import { DeleteButton } from "../../../../app/components/DeleteButton";
import { CancelButton } from "../../../../app/components/CancelButton";

interface DeleteSysMailTemplateDialogProps {
    templateId: string;
    onCancel: () => void;
    onSuccess: () => void;
}

export const DeleteSysMailTemplateDialog = ({ templateId, onCancel, onSuccess }: DeleteSysMailTemplateDialogProps) => {
    const dispatch = useAppDispatch();
    
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState<string>("");

    const handleSubmitClick = async () => {
        setLoading(true)
        try {
            await dispatch(deleteSysMailTemplate(templateId)).unwrap();

            onSuccess()
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="sys-mail-template-delete">
                    <span>_Usuń szablon</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="warning"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="sys-mail-template-delete-alert">
                                <span>_Czy na pewno chcesz usunąć ten szablon?</span>
                            </Localized>
                        </Typography>
                    </Alert>
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <DeleteButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}